import propsTypes from "prop-types";
import { useState } from "react";
import { connect } from "react-redux";
import InputType from "./InputType";
import { InputLabel, InputError } from "./style";
import "./style.css";

const Input = ({
  name,
  label,
  placeHolder,
  value,
  className,
  type,
  maxLength,
  minLength,
  style,
  seq,
  styleType,
  onChange,
  autocomplete,
  labelClass,
  typeInput,
  theme,
  disabled,
  refrence,
}) => {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    if (typeInput) {
      InputType[typeInput](
        name,
        e.target.value,
        handleTypeInput,
        setError,
        setErrorMessage
      );
    } else {
      changeValue(name, e.target.value);
    }
  };

  const handleTypeInput = (name, value) => {
    changeValue(name, value);
  };

  const changeValue = (name, value) => {
    onChange(name, value);
  };

  var classStyle;

  switch (styleType) {
    case "v1":
      classStyle = "input-default";
      break;
    default:
      classStyle = "input-default-v2";
      break;
  }

  return (
    <>
      {label ? (
        <InputLabel
          className={`d-block mb-1 ${seq ? " mr-3" : " mr-1"} ${labelClass}`}
          theme={theme}
        >
          {label}
        </InputLabel>
      ) : (
        false
      )}
      <input
        name={name}
        ref={refrence}
        placeholder={placeHolder}
        value={value}
        className={`form-control ${classStyle} ${
          error ? "is-invalid" : false
        } ${seq ? "inputseq" : false} ${
          theme?.isDarkTheme ? "dark" : ""
        } ${className}`}
        type={type}
        maxLength={maxLength}
        minLength={minLength}
        style={style}
        onChange={handleChange}
        autoComplete={autocomplete}
        disabled={disabled}
      />
      {error ? (
        <InputError className="invalid-feedback text-right mt-2 mr-1">
          {errorMessage}
        </InputError>
      ) : (
        false
      )}
    </>
  );
};

Input.propsTypes = {
  name: propsTypes.string,
  label: propsTypes.string,
  placeHolder: propsTypes.string,
  value: propsTypes.string,
  className: propsTypes.string,
  type: propsTypes.string,
  maxLength: propsTypes.number,
  minLength: propsTypes.number,
  style: propsTypes.string,
  autocomplete: propsTypes.string,
  seq: propsTypes.bool,
  disabled: propsTypes.bool,
  styleType: propsTypes.string,
  typeInput: propsTypes.string,
  labelClass: propsTypes.string,
  onChange: propsTypes.func,
};

Input.defaultProps = {
  type: "text",
  styleType: "v1",
  disabled: false,
  seq: false,
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Input);
